import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  Language,
  getDirection,
  translations,
} from '../thi/thi-translations';
import { normalizeThiLang } from '../thi/thi-lang.util';
import {
  THI_LANDING_ARTICLES,
  ThiArticleListItem,
  ArticleCategory,
} from '../thi/thi-articles-list.data';

@Component({
  selector: 'app-thi-articles',
  templateUrl: './thi-articles.component.html',
  styleUrls: ['./thi-articles.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThiArticlesComponent implements OnInit {
  landingLang: Language = 'ar';
  dir: 'rtl' | 'ltr' = 'rtl';
  t = translations.ar;

  allArticles = THI_LANDING_ARTICLES;
  activeFilter: 'all' | ArticleCategory = 'all';

  filterIds: { id: 'all' | ArticleCategory; label: string; icon?: string }[] = [];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    const raw = localStorage.getItem('curentLang') || 'ar';
    this.landingLang = normalizeThiLang(raw);
    this.dir = getDirection(this.landingLang);
    this.t = translations[this.landingLang];
    this.buildFilters();
  }

  setFilter(id: 'all' | ArticleCategory): void {
    this.activeFilter = id;
    this.cdr.markForCheck();
  }

  private buildFilters(): void {
    const f = this.t.resources.filters;
    this.filterIds.length = 0;
    this.filterIds.push(
      { id: 'all', label: f.all, icon: 'fa fa-th-large' },
      { id: 'business', label: f.business, icon: 'fa fa-briefcase' },
      { id: 'finance', label: f.finance, icon: 'fa fa-line-chart' },
      { id: 'productivity', label: f.productivity, icon: 'fa fa-bolt' },
      { id: 'technology', label: f.technology, icon: 'fa fa-microchip' },
    );
  }

  get filteredArticles(): ThiArticleListItem[] {
    if (this.activeFilter === 'all') return this.allArticles;
    return this.allArticles.filter((a) => a.category === this.activeFilter);
  }

  get arrowIcon(): string {
    return this.dir === 'rtl' ? 'fa fa-arrow-left' : 'fa fa-arrow-right';
  }

  categoryLabel(cat: ArticleCategory): string {
    const m = this.t.resources.filters;
    const map: Record<ArticleCategory, keyof typeof m> = {
      business: 'business',
      finance: 'finance',
      productivity: 'productivity',
      technology: 'technology',
    };
    return (m as any)[map[cat]] as string;
  }
}
